<template>
    <modal :title="$t(title)" :visible.sync="isShowDialog" width="50%">
        <BaseDetail v-bind="$attrs"></BaseDetail>
        <div slot="footer">
            <el-button type="primary" @click="isShowDialog = false">
                {{ $t('buttonTitle.Close') }}
            </el-button>
            <!-- <el-button type="primary">
                {{ $t('数据处理') }}
            </el-button> -->
        </div>
    </modal>
</template>

<script>
import BaseDetail from './baseDetail.vue'
import { sensorHistory } from '@/utils/winDetail'
import { sensorHistoryQueryFormat } from '@/utils/simplify/query'
export default {
  props: {
    isShowDetail: {},
    title: {}
  },
  components: {
    BaseDetail
  },
  computed: {
    isShowDialog: {
      get: function () {
        return this.isShowDetail
      },
      set: function (val) {
        this.$emit('update:isShowDetail', val)
      }
    }
  },
  methods: {
    historyFn () {
      const params = sensorHistoryQueryFormat(this.$attrs.detailObj)
      sensorHistory(params)
    }
  }
}
</script>
